import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Microscope = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="m24.37 24.765-.494-1.564-1.317.411-.494-1.358-5.802 2.14.411 1.111-1.399.453-2.428-8.848 1.687-.741.494 1.975 1.523-.411.576 2.222 2.798-.7-.576-2.222 1.276-.329-2.428-9.465-1.317.329V5.999l-4.074.988.946 1.605-1.193.288.535 2.14-7.119 2.263v18.888h1.646V14.517l5.926-1.852.535 2.14-3.21 1.44L15.111 31.8l1.605-.453-1.029-3.786 8.683-2.798zm-5.802-9.012-2.387.617-1.605-6.255 2.387-.617 1.605 6.255z"
    />
    <path
      fill={props.fill}
      d="M26.222 34.6H4v-3.951h18.559l3.662 3.951zm4.658-19.57-2.807 2.838 1.17 1.158 2.807-2.838-1.17-1.157zm3.862 5.328-3.85 1.055.435 1.588 3.85-1.055-.435-1.588zm-3.18 6.135-.417 1.592 3.862 1.011.417-1.592-3.862-1.011z"
    />
  </svg>
);

export default SvgCovid19Microscope;
